import { promoCards } from '../../../constant/GuestHomePageConstants';
import PromoCard from './PromoCard';

const WellnessPromoSection = () => {
  return (
    <section className="container-standard py-10 md:py-14">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 2xl:gap-8">
        {promoCards?.map((card) => <PromoCard key={card.eyebrow} {...card} />)}
      </div>
    </section>
  );
};

export default WellnessPromoSection;
